

































































import Vue from 'vue';
import { Watch, Component } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

@Component({
  components: {},
  name: 'validate-reservation-code',
  props: {
    // Toggle this to clear all form fields; the value doesn't matter, only the change.
    clearFormFields: Boolean,
    reservationCodeProp: String,
  },
  watch: {
    clearFormFields: 'clearReservationCodeField',
  },
})
export default class ValidateReservationCode extends Vue {
  reservationCode = '';
  disableValidateButton = true;
  errorMessage = '';
  tokenData = {};

  created() {
    this.reservationCode = this.$props.reservationCodeProp || '';
  }

  clearReservationCodeField() {
    this.reservationCode = '';
  }

  onQuit() {
    this.clearReservationCodeField();
  }

  validateReservationCode() {
    const button = document.getElementById('validate-reservation-code-button');
    if (button != null) {
      button.classList.remove('validate-reservation-code-button');
      button.classList.add(
        'validate-reservation-code-disabled-button-after-click'
      );
    }

    Promise.all([this.isApplicationSubmitted(), this.validateEnrollment()])
      .then((values) => {
        const isApplicationSubmitted = values[0];
        if (!isApplicationSubmitted) {
          const response = values[1];
          const productRoute = this.getProductRoute(response.data.data);
          this.$emit('reservationCodeValidated', response.data);
          this.$router.push({
            name: productRoute,
            params: {
              tokenData: JSON.stringify(response.data.data),
            },
          });
        } else {
          // application already submitted for this token
          this.errorMessage =
            'The reservation code entered is invalid. Please check that it has been entered correctly and is valid.';
          if (button != null) {
            button.classList.remove(
              'validate-reservation-code-disabled-button-after-click'
            );
            button.classList.add('validate-reservation-code-button');
          }
        }
      })
      .catch(() => {
        // error response
        this.errorMessage =
          'The reservation code entered is invalid. Please check that it has been entered correctly and is valid.';
        if (button != null) {
          button.classList.remove(
            'validate-reservation-code-disabled-button-after-click'
          );
          button.classList.add('validate-reservation-code-button');
        }
      });
  }

  isApplicationSubmitted() {
    const isApplicationSubmittedUrl: string =
      '/api/kcc/application/submitted/' + this.reservationCode;
    return this.$http
      .get(isApplicationSubmittedUrl)
      .then((response: AxiosResponse) => {
        return response.data.data;
      });
  }

  validateEnrollment() {
    // Prior validation check in initial home page should prevent this code running without a token value,
    // but will defensively fall back to 'noTokenDetected' in the event the value is blank/undefined.
    const validateTokenUrl: string =
      '/api/kcas/enrollment/token/validate/' + this.reservationCode;

    return this.$http.get(validateTokenUrl);
  }

  @Watch('reservationCode')
  enableNextButtonIfCodeInputIsNotEmpty() {
    if (this.reservationCode.length > 0) {
      this.disableValidateButton = false;
    } else {
      this.disableValidateButton = true;
    }
  }

  getProductRoute(tokenData: any) {
    const dataDescriptionJson = tokenData.verificationData.dataDescription;
    const dataDescriptionArray = JSON.parse(dataDescriptionJson);
    const productShortname = dataDescriptionArray.filter(
      (row: any) => row.key == 'product'
    )[0].value;
    return productShortname;
  }

  onFocus() {
    const label = document.getElementById('reservation-code-input-label');
    if (label != null) {
      label.classList.remove('reservation-code-input-label');
      label.classList.add('on-focus-reservation-code-input-label');
    }
  }

  onBlur() {
    const label = document.getElementById('reservation-code-input-label');
    if (this.reservationCode.length < 1 && label != null) {
      label.classList.remove('on-focus-reservation-code-input-label');
      label.classList.add('reservation-code-input-label');
    }
  }
}
